/**
 * Countdown Calculator Utility
 * 
 * Pure functions for countdown calculations
 * No state, no side effects, no React dependencies
 */

/**
 * Calculate countdown time components
 * @param {number} openingDayTimestamp - Target date timestamp (milliseconds)
 * @param {number} nowTimestamp - Current time timestamp (milliseconds)
 * @returns {object} { days, hours, minutes, seconds, isReached }
 */
export function calculateCountdown(openingDayTimestamp, nowTimestamp) {
  const remaining = Math.max(0, openingDayTimestamp - nowTimestamp);
  
  return {
    days: Math.floor(remaining / (1000 * 60 * 60 * 24)),
    hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((remaining / (1000 * 60)) % 60),
    seconds: Math.floor((remaining / 1000) % 60),
    isReached: remaining === 0,
  };
}

/**
 * Format countdown value with zero-padding
 * @param {number} value - Value to format
 * @returns {string} Zero-padded string (e.g., "05")
 */
export function formatCountdownValue(value) {
  return String(value).padStart(2, '0');
}

/**
 * Get opening day timestamp
 * Default: Monday, July 13, 2026 at 07:00 UTC+7
 * @param {string} dateString - Optional custom date string
 * @returns {number} Timestamp in milliseconds
 */
export function getOpeningDayTimestamp(dateString = '2026-07-13T07:00:00+07:00') {
  return new Date(dateString).getTime();
}
